import { render, staticRenderFns } from "./EmployeePointsUpdates.vue?vue&type=template&id=51a41f18&"
import script from "./EmployeePointsUpdates.vue?vue&type=script&lang=js&"
export * from "./EmployeePointsUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports